import React, { useState,useRef } from "react";
import searchIcon from "../../assets/search-icon.svg";
import { useTranslation } from "react-i18next";
import UpArrow from '../../assets/up-arrow.svg'
import DownArrow from '../../assets/down-arrow.svg'
import Loader from "../../components/Loader";
interface SalesmanListProps {
  selctedEmp: any;
  handleEmpSected: any;
  employeeData: any;
  isDropdownOpen: any;
  setIsDropdownOpen: any;
  selectedEmpPopup: any;
  handleSelectedEmpIcon: any;
  infoIconClick: any;
  activePopupIndex: any;
  markarData: any;
  employeeSchedule: any;
  selectedFromReports: any;
  popupref:any;
  empLoader:any;
  selectedMarker:any;
  sortBy: string;
  onSortByChange: (value: string) => void;
  fromLMD?: boolean;
  selectedPlanningFilter?: string;
  onPlanningFilterChange?: (value: string) => void;
}

const SalesmanList: React.FC<SalesmanListProps> = ({
  selctedEmp,
  handleEmpSected,
  employeeData,
  isDropdownOpen,
  setIsDropdownOpen,
  selectedEmpPopup,
  infoIconClick,
  activePopupIndex,
  handleSelectedEmpIcon,
  markarData,
  employeeSchedule,
  selectedFromReports,
  popupref,
  empLoader,
  selectedMarker,
  sortBy,
  onSortByChange,
  fromLMD = false,
  selectedPlanningFilter = "",
  onPlanningFilterChange,
}) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const listItemRefs = useRef<{ [key: string]: HTMLLIElement | null }>({});
  const filteredSalespeople = employeeData
  ?.filter((person: any) => {
    if (!searchTerm) return true;
    const matchesName = person.name_eng?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesId = person.emp_id?.toString().includes(searchTerm);
    return matchesName || matchesId;
  })
  .sort((a: any, b: any) => {
    if (selectedFromReports && selctedEmp?.emp_id === a.emp_id) return -1;
    if (selectedFromReports && selctedEmp?.emp_id === b.emp_id) return 1;

    return 0;
  });
  type Status = "AT_LOCATION" | "IDLE" | "ENROUTE";

  const getStatusColor = (status: Status): string => {
    switch (status) {
      case "AT_LOCATION":
        return "cugreen";
      case "IDLE":
        return "customorange";
      case "ENROUTE":
        return "purple";
      default:
        return "black";
    }
  };

  return (
    <>
      
      <div className="relative sticky top-7 z-1 flex items-center gap-2 pb-4  mb-1 w-full p-4">
        <div className="relative w-full pt-4">
          <span className="absolute left-2 top-1/2 pt-3 -translate-y-1/2">
            <img src={searchIcon} alt="Search Icon" className="h-5 w-5" />
          </span>
          <input
            type="text"
            placeholder={t("SalesmanList.search")}
            className="pl-9 p-2 border rounded w-full"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="flex flex-col gap-1 shrink-0">
          <label htmlFor="salesman-sort-visits" className="text-10 text-gray-600 whitespace-nowrap">
            Sort By Visits
          </label>
          <select
            id="salesman-sort-visits"
            value={sortBy}
            onChange={(e) => onSortByChange(e.target.value)}
            className="p-2 border rounded min-w-[130px] text-sm"
          >
            <option value="">None</option>
            <option value="visits_desc">High to Low</option>
            <option value="visits_asc">Low to High</option>
          </select>
        </div>
        {fromLMD && (
          <div className="flex flex-col gap-1 shrink-0">
            <label htmlFor="planning-filter" className="text-10 text-gray-600 whitespace-nowrap">
              Delivery Type
            </label>
            <select
              id="planning-filter"
              value={selectedPlanningFilter}
              onChange={(e) => onPlanningFilterChange?.(e.target.value)}
              className="p-2 border rounded min-w-[120px] text-sm"
            >
              <option value="">All</option>
              <option value="planned">Planned</option>
              <option value="unplanned">Unplanned</option>
            </select>
          </div>
        )}
      </div>
      <div className="border-b-2"></div>
      {empLoader && <Loader/>}
      <div className="block md:hidden p-4">
        <button
          className="w-full flex items-center justify-between p-2 border rounded-md shadow-sm  font-semibold"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <span>{"All employee"}</span>
          <span className="ml-2">
            {isDropdownOpen ? <img src={UpArrow} alt='up'/> : <img src={DownArrow} alt='down'/>}
          </span>
        </button>
        {selctedEmp?.emp_id && (
          <div className="pt-3">
            <div
              className={`${
                selctedEmp.active === false 
                  ? 'bg-red-100' 
                  : `bg-${getStatusColor(selctedEmp.activity_status)}`
              } relative flex items-center justify-between p-2 border rounded-md shadow-sm cursor-pointer hover:bg-[#00C48C]/50 "`}
            >
              <div className="flex items-center space-x-2 cursor-pointer">
                <span className={`rounded w-1.5 h-12 bg-white`} />
                <div>
                  <p className={`text-white font-bold	text-16`}>
                    {selctedEmp.emp_id} - {selctedEmp.name_eng}
                  </p>
                  <p className={`text-white font-medium`}>
                    {selctedEmp.channel_name} ({selctedEmp.channel_id})
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="pl-4 pr-4 ">
        <ul
          className={`${
            isDropdownOpen
              ? "block absolute bg-white z-50 w-[92%] overflow-auto"
              : "hidden"
          }md:block space-y-4 h-[calc(100vh-500px)] max-h-[calc(100vh-400px)] overflow-y-auto	overflow-x-hidden	 mt-2 scrollbar scrollbar-thin `}
        >
          {!empLoader &&  filteredSalespeople.map((person: any, index: any) => (
            <li
              key={index}
              ref={(el) => (listItemRefs.current[person.emp_id] = el)}
              className={`${
                selctedEmp.emp_id === person.emp_id
                  ? `relative bg-${getStatusColor(person.activity_status)}`
                  : `relative ${person.active === false ? 'bg-red-100' : ''}`
              } flex items-center gap-1 p-2 border rounded shadow-sm hover:bg-[#00C48C]/50 "`}
            >
              <div
                className="flex items-center gap-2 cursor-pointer w-full h-full"
                
                onClick={() => handleEmpSected(person , true)}
              >
                <div
                  className={`rounded w-[5px] max-w-[5px] h-14 flex-1 bg-${
                    selctedEmp.emp_id === person.emp_id
                      ? "white"
                      : getStatusColor(person.activity_status)
                  }`}
                />
                <div className="flex-1">
                  <p
                    className={`${
                      selctedEmp.emp_id === person.emp_id
                        ? "text-white font-bold text-16"
                        : "text-black font-bold text-16"
                    }`}
                  >
                    {person.emp_id} - {person.name_eng}
                  </p>
                  <div className="mt-1 pt-1 border-t border-gray-300 flex justify-between gap-2 text-xs">
                    <div className="flex-1 min-w-0">
                      <p
                        className={`whitespace-normal break-words ${
                          selctedEmp.emp_id === person.emp_id
                            ? "text-white font-medium"
                            : "text-black font-medium"
                        }`}
                      >
                        {person.channel_name} ({person.channel_id})
                      </p>
                      <p
                        className={`whitespace-normal break-words ${
                          selctedEmp.emp_id === person.emp_id
                            ? "text-white font-medium"
                            : "text-black font-medium"
                        }`}
                      >
                        {person.sales_office_region}, {person.sales_office_name}
                      </p>
                    </div>
                    <div className="flex-1 min-w-0 border-l border-gray-300 pl-2">
                      {fromLMD ? (
                        <>
                          <p
                            className={`truncate ${
                              selctedEmp.emp_id === person.emp_id
                                ? "text-white font-medium"
                                : "text-black font-medium"
                            }`}
                          >
                            Total Visits: {person.total_visits ?? 0}
                          </p>
                          <p
                            className={`truncate ${
                              selctedEmp.emp_id === person.emp_id
                                ? "text-white font-medium"
                                : "text-black font-medium"
                            }`}
                          >
                            {t("visit.total_delivered_visits")}:{" "}
                            {person.total_delivered_visits ??
                              person.successful_visits ??
                              0}
                          </p>
                        </>
                      ) : (
                        <>
                          <p
                            className={`truncate ${
                              selctedEmp.emp_id === person.emp_id
                                ? "text-white font-medium"
                                : "text-black font-medium"
                            }`}
                          >
                            Planned: {person.total_planned_visits ?? 0}
                          </p>
                          <p
                            className={`truncate ${
                              selctedEmp.emp_id === person.emp_id
                                ? "text-white font-medium"
                                : "text-black font-medium"
                            }`}
                          >
                            Unplanned: {person.total_unplanned_visits ?? 0}
                          </p>
                          <p
                            className={`truncate ${
                              selctedEmp.emp_id === person.emp_id
                                ? "text-white font-medium"
                                : "text-black font-medium"
                            }`}
                          >
                            Visited Planned: {person.total_visited_planned_visits ?? 0}
                          </p>
                          <p
                            className={`truncate ${
                              selctedEmp.emp_id === person.emp_id
                                ? "text-white font-medium"
                                : "text-black font-medium"
                            }`}
                          >
                            Total Visits: {person.total_visits ?? 0}
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SalesmanList;
